const RAZORPAY_SCRIPT = 'https://checkout.razorpay.com/v1/checkout.js';

let razorpayScriptPromise = null;

export function loadRazorpayScript() {
  if (typeof window !== 'undefined' && window.Razorpay) {
    return Promise.resolve(window.Razorpay);
  }
  if (razorpayScriptPromise) {
    return razorpayScriptPromise;
  }
  razorpayScriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = RAZORPAY_SCRIPT;
    script.async = true;
    script.onload = () => {
      if (window.Razorpay) {
        resolve(window.Razorpay);
        return;
      }
      reject(new Error('Razorpay failed to load'));
    };
    script.onerror = () => reject(new Error('Failed to load Razorpay checkout'));
    document.body.appendChild(script);
  });
  return razorpayScriptPromise;
}

export class RazorpayCheckoutCancelledError extends Error {
  constructor(message = 'Payment cancelled') {
    super(message);
    this.name = 'RazorpayCheckoutCancelledError';
  }
}

export const RAZORPAY_PAYMENT_FAILED_MESSAGE =
  "Your payment didn't go through due to a temporary issue. Any debited amount will be refunded in 4-5 business days.";

export class RazorpayPaymentFailedError extends Error {
  constructor(message = RAZORPAY_PAYMENT_FAILED_MESSAGE) {
    super(message);
    this.name = 'RazorpayPaymentFailedError';
  }
}

export function isRazorpayTestKey(keyId) {
  return String(keyId || '').startsWith('rzp_test_');
}

export const RAZORPAY_TEST_PAYMENT_HINT =
  'Test mode: do not scan the QR with PhonePe or GPay. In the Razorpay window, choose UPI and enter success@razorpay, or pay with test card 4111 1111 1111 1111.';

export async function openRazorpayCheckout({
  keyId,
  orderId,
  amount,
  currency = 'INR',
  name = 'Eats',
  description = 'Grocery order',
  prefill = {},
  themeColor = '#014287',
  testMode = false,
}) {
  const Razorpay = await loadRazorpayScript();
  const inTestMode = testMode || isRazorpayTestKey(keyId);

  return new Promise((resolve, reject) => {
    const options = {
      key: keyId,
      amount,
      currency,
      name,
      description: inTestMode
        ? 'Test payment — use UPI success@razorpay inside checkout'
        : description,
      order_id: orderId,
      prefill,
      theme: { color: themeColor },
      notes: inTestMode
        ? { payment_hint: 'Do not scan QR in test mode. Use success@razorpay in UPI field.' }
        : undefined,
      handler(response) {
        resolve(response);
      },
      modal: {
        ondismiss() {
          reject(new RazorpayCheckoutCancelledError());
        },
      },
    };

    const checkout = new Razorpay(options);
    checkout.on('payment.failed', () => {
      reject(new RazorpayPaymentFailedError());
    });
    checkout.open();
  });
}
